enum Fields {
    OldPassword = 'oldPassword',
    NewPassword = 'newPassword',
}

export default Fields;
